export const experienceConfig = {
  media: {
    duration: 31.765,
    playbackRate: 0.7,
    loopFadeLead: 0.72,
    poster: "/assets/images/forest-poster.webp",
    sources: [
      {
        id: "720",
        src: "/assets/video/forest-720.mp4",
        width: 1280,
        height: 720
      },
      {
        id: "1080",
        src: "/assets/video/forest-1080.mp4",
        width: 1920,
        height: 1080
      },
      {
        id: "4k",
        src: "/assets/video/forest-2160.mp4",
        width: 3840,
        height: 2160
      }
    ]
  },
  scene: {
    particles: {
      high: 48,
      medium: 28,
      low: 0,
      hardLimit: 80
    },
    pixelRatio: {
      high: 1.5,
      medium: 1,
      low: 1
    },
    parallax: {
      near: 12,
      middle: 6,
      far: 2,
      video: 1
    }
  },
  performance: {
    highMinimumFps: 45,
    mediumMinimumFps: 30,
    sampleWindowMs: 5000
  },
  audio: {
    baseGain: 0.2,
    maximumGain: 0.27,
    scrollGainRange: 0.07
  },
  animals: {
    innerDistance: 80,
    outerDistance: 160,
    mobileHitScale: 1.15,
    slowRate: 0.48,
    slowHoldMs: 800,
    cueText: "林间有动静"
  },
  features: {
    cursorTrail: true,
    leafSwipe: true,
    holdStages: true,
    cardDrag: false,
    freeLook: true,
    windGestures: true,
    circleGesture: false,
    mistModes: true,
    idleMode: true,
    spatialAudio: false,
    haptics: true
  }
};
